import React from "react";
import './mobilesetting.css'
import { Container, Row, Col } from "react-bootstrap"
import { Link, useHistory } from "react-router-dom"
import onClickOutside from "react-onclickoutside";
import { logout } from "../../functions/general"
import { AtSymbolIcon, EyeIcon, GlobeIcon, LockClosedIcon, LogoutIcon, QuestionMarkCircleIcon, ServerIcon } from '@heroicons/react/outline';
import { CogIcon, PencilAltIcon } from '@heroicons/react/solid';
import API_ENDPOINT from "../../wm.api.service";
import { connect } from "react-redux";
import { decode } from "base-64";
import Cookies from "universal-cookie";


const cookies = new Cookies();
function MobileSettings({ setting, close, rootData, resume }) {
    if (cookies.get("wmusers")) {
        var user = decode(cookies.get("wmusers"));
    } else {
        var user = 'members';
    }
    const history = useHistory();
    MobileSettings.handleClickOutside = () => close();
    const logouts = () => {
        logout();
        history.replace("/");
    }
    return (
        <>
            <div className={`settingsmobile fixed w-full bottom-0 bg-white shadow-2xl ${setting ? "slideSettingsUp" : ""}`}>
                <Container fluid>
                    <Row className="divide-y divide-gray-200">
                        <Col md={12}>
                            <div className=" py-3 text-sm manpro" onClick={() => close()}>
                                <a href={`${API_ENDPOINT.publicURL}/${rootData.user.username}`} className="w-full h-full block">
                                    <div className='flex items-center space-x-2'>
                                        <EyeIcon className=' w-6' />
                                        <span className='text-base manpro text-gray-700'>Profile view</span>
                                    </div>
                                </a>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className=" py-3 text-sm manpro" onClick={() => close()}>
                                <Link to="/account" className="w-full h-full block">
                                    <div className='flex items-center space-x-2'>
                                        <CogIcon className=' w-6' />
                                        <span className='text-base manpro text-gray-700'>Account setting</span>
                                    </div>
                                </Link>
                            </div>
                        </Col>
                        {user === 'members' && <Col md={12}>
                            <div className="py-3 text-sm manpro" onClick={() => close()}>
                                <Link to="/createblogs" className="w-full h-full block">
                                    <div className='flex items-center space-x-2'>
                                        <PencilAltIcon className=' w-6' />
                                        <span className='text-base manpro text-gray-700'>Create blog</span>
                                    </div>
                                </Link>
                            </div>
                        </Col>}

                        {user === 'members' && <Col md={12}>
                            <div className="py-3 text-sm manpro" onClick={() => close()}>
                                <Link to="/createquestions" className="w-full h-full block">
                                    <div className='flex items-center space-x-2'>
                                        <QuestionMarkCircleIcon className=' w-6' />
                                        <span className='text-base manpro text-gray-700'>Create question</span>
                                    </div>
                                </Link>
                            </div>
                        </Col>}


                        {/* {user === 'members' && <>{rootData.isResumeCreated || resume.isResumeCreated ? <Col md={12}>
                            <div className="py-3 text-sm manpro" onClick={() => close()}>
                                <Link to={`/editresume/${encode('about-me')}`} className="w-full h-full block">
                                    <div className='flex items-center space-x-2'>
                                        <PencilIcon className=' w-6' />
                                        <span className='text-base manpro text-gray-700'>Edit Resume</span>
                                    </div>
                                </Link>
                            </div>
                        </Col> : <Col md={12}>
                            <div className="py-3  border-b border-gray-400 border-solid text-sm manpro" onClick={() => close()}>
                                <Link to={`/createresume/${encode('about-me')}`} className="w-full h-full block">
                                    <div className='flex items-center space-x-2'>
                                        <PencilIcon className=' w-6' />
                                        <span className='text-base manpro text-gray-700'>Create Resume</span>
                                    </div>
                                </Link>
                            </div>
                        </Col>} </>} */}

                        <Col md={12}>
                            <div className=" py-3 text-sm manpro" onClick={() => close()}>
                                <a href="https://wisemonkeys.info/legals/aboutus" className="w-full h-full block text-black no-underline">
                                    <div className='flex items-center space-x-2'>
                                        <AtSymbolIcon className=' w-6' />
                                        <span className='text-base manpro text-gray-700'>About us</span>
                                    </div>
                                </a>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="py-3  text-sm manpro" onClick={() => close()}>
                                <a href="https://wisemonkeys.info/legals/terms" className="w-full h-full block text-black no-underline">
                                    <div className='flex items-center space-x-2'>
                                        <ServerIcon className=' w-6' />
                                        <span className='text-base manpro text-gray-700'>Terms of service</span>
                                    </div>
                                </a>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="py-3  text-sm manpro" onClick={() => close()}>
                                <a href="https://wisemonkeys.info/legals/privacy" className="text-black no-underline">
                                    <div className='flex items-center space-x-2'>
                                        <LockClosedIcon className=' w-6' />
                                        <span className='text-base manpro text-gray-700'>Privacy Policy</span>
                                    </div>
                                </a>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="py-3  text-sm manpro" onClick={() => close()}>
                                <a href="https://wisemonkeys.info/legals/cookies" className="text-black no-underline">
                                    <div className='flex items-center space-x-2'>
                                        <GlobeIcon className=' w-6' />
                                        <span className='text-base manpro text-gray-700'>Cookies policy</span>
                                    </div>
                                </a>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className=" py-3 text-sm manpro" onClick={() => logouts()}>
                                <div className='flex items-center space-x-2'>
                                    <LogoutIcon className=' w-6' />
                                    <span className='text-base manpro text-gray-700'>Logout</span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

const clickOutsideConfig = {
    handleClickOutside: () => MobileSettings.handleClickOutside
};


const mapStateToProps = (state) => {
    return state;
};
export default connect(mapStateToProps, null)(onClickOutside(MobileSettings, clickOutsideConfig));
